import axios from "axios";
import { apiUrl } from "../constants/api";

export const $http = axios.create({
  baseURL: apiUrl,
});
